














































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  ReminderModel,
  RemindersClient,
  DistributorsClient,
} from "@/diamond-support-api";
import { Action, State } from "vuex-class";
import UrgentReminderList from "@/components/dashboards/UrgentReminderList.vue";
import PopUp from "@/components/app/PopUp.vue";
import RemoveItemDialog from "@/components/app/RemoveItemDialog.vue";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";

@Component({
  components: {
    UrgentReminderList,
    RemoveItemDialog,
    PopUp,
  },
})
export default class ReminderList extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;

  items: ReminderModel[] = [];
  reminders: ReminderModel[] = [];
  urgentReminders: ReminderModel[] = [];
  reminder: ReminderModel = new ReminderModel();
  remindersApi = new RemindersClient();
  distributorNoteApi = new DistributorsClient();

  search = "";

  removeItem: ReminderModel | null = null;
  removeMessage = "";
  showRemoveDialog = false;

  showReminderPopUp = false;
  popUpMessage = "";
  showCompletePopUp = false;
  completeMessage = "";
  completeItem: ReminderModel | null = null;

  headers: any[] = [
    {
      text: "Distributor Id",
      value: "distributorId",
      align: "center",
      sortable: false,
    },
    {
      text: "Content",
      value: "content",
      sortable: false,
      width: "35%",
    },
    {
      text: "Updated time",
      value: "updatedUtc",
      sortable: false,
      align: " d-none",
    },
    {
      text: "Due On",
      value: "dueOnUtc",
            sortable: false,

    },
    {
      text: "Edit",
      align: "center",
      sortable: false,
      value: "edit",
    },
    {
      text: "Delete",
      align: "center",
      sortable: false,
      value: "delete",
    },
    {
      text: "Complete",
      align: "center",
      sortable: false,
      value: "complete",
    },
  ];

  async mounted() {
    this.items = await this.remindersApi.getAll();
    this.reminders = this.items.filter((elem) => elem.dueOnUtc! > new Date());
    this.urgentReminders = this.reminders.filter(
      (elem) => elem.isUrgent === true && elem.completedOnUtc == null
    );
    if (this.urgentReminders.length > 0) {
      this.showReminderPopUp = true;
      if (this.urgentReminders.length === 1)
        this.popUpMessage = `There is an incomplete urgent reminder`;
      else {
        this.popUpMessage = `There are incomplete urgent reminders`;
      }
    }
  }

  editReminder(id: string) {
    this.$router.push({
      path: `/userDashboard/${id}/reminderEdit`,
    });
  }

  removeReminder(reminder: ReminderModel) {
    this.removeItem = reminder;
    this.removeMessage = `Are you sure you want to remove the urgent reminder for distributor Id ${reminder.distributorId} ?`;
    this.showRemoveDialog = true;
  }

  completeReminder(reminder: ReminderModel) {
    this.completeItem = reminder;
    this.completeMessage = `Are you sure you want to complete the urgent reminder for distributor Id ${reminder.distributorId} ?`;
    this.showCompletePopUp = true;
  }

  customSort() {
    return this.reminders.sort((a, b) => {
      return <any>new Date(b.updatedUtc!) - <any>new Date(a.updatedUtc!);
    });
  }

  reminderUpdated(reminder: ReminderModel) {
    let index = this.reminders!.map(function (x) {
      return x.id;
    }).indexOf(reminder.id);
    if (index >= 0) this.reminders!.splice(index, 1, reminder);
  }

  reminderRemoved(reminder: ReminderModel) {
    let index = this.reminders!.map(function (x) {
      return x.id;
    }).indexOf(reminder.id);
    if (index >= 0) this.reminders!.splice(index, 1);
  }

  reminderCompleted(reminder: ReminderModel) {
    let index = this.reminders!.map(function (x) {
      return x.id;
    }).indexOf(reminder.id);
    if (index >= 0) this.reminders!.splice(index, 1, reminder);
  }

  confirmUrgentReminder() {
    this.showReminderPopUp = false;
    this.$router.push({
      path: `/userDashboard/urgentReminderList`,
    });
  }

  async confirmRemove() {
    if (this.removeItem) {
      await this.remindersApi
        .delete(this.removeItem)
        .then((response) => {
          if (response !== null) this.reminderRemoved(this.removeItem!);
          this.showMessage(new SuccessMessage(`Reminder has been deleted.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.showRemoveDialog = false;
  }

  async confirmCompleteReminder(reminder: ReminderModel) {
    if (this.completeItem) {
      this.completeItem.completedOnUtc = new Date();
      await this.remindersApi
        .put(this.completeItem)
        .then((response) => {
          if (response !== null) this.reminderCompleted(this.completeItem!);
          this.showMessage(new SuccessMessage(`Reminder has been completed.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.showCompletePopUp = false;
  }
}
